var map = {
	"./AcidBlade.mp4": 2978,
	"./AcidClub.mp4": 7,
	"./AcidScepter.mp4": 6406,
	"./AcidSword.mp4": 3371,
	"./BlackRose.mp4": 929,
	"./BloodLustSword.mp4": 3456,
	"./BodhiSword.mp4": 6194,
	"./BronzeDragonSlayer.mp4": 9418,
	"./BubbleUmbrella.mp4": 6918,
	"./CakePop.mp4": 4199,
	"./DeadlyThorn.mp4": 9887,
	"./DemonicBlade.mp4": 9458,
	"./DragonBlade.mp4": 3270,
	"./DragonHowl.mp4": 5675,
	"./ElementsBlade.mp4": 8902,
	"./EmeraldScythe.mp4": 2651,
	"./FloralWeapon.mp4": 2148,
	"./GoldenDagger.mp4": 6508,
	"./GoldenDragonSlayer.mp4": 8757,
	"./GraspofLove.mp4": 833,
	"./JadeBlade.mp4": 2085,
	"./JadeSword.mp4": 1063,
	"./KingCatStaff.mp4": 5162,
	"./Knife.mp4": 2050,
	"./LavaBlade.mp4": 5559,
	"./LightSword.mp4": 5312,
	"./PhoenixDream(Sparkle).mp4": 2573,
	"./PinkyBlade.mp4": 1092,
	"./PinkyClub.mp4": 4472,
	"./PinkySword.mp4": 3921,
	"./RedBuriedBlade.mp4": 2060,
	"./RedCurse.mp4": 9618,
	"./SilverDragonSlayer.mp4": 4690,
	"./StarGazerSword.mp4": 4532,
	"./SwordofElements.mp4": 5869,
	"./ThorFireHammer.mp4": 8095,
	"./ThorIceHammer.mp4": 2664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9354;